import logo from './logo.svg';
import './App.css';
import Layoutd from './Layout';

function App() {
  return (
    <div className="App">
      <header>
        <Layoutd/>
      </header>
    </div>
  );
}

export default App;
